export const allSupportedLocales = ['en', 'de', 'es', 'fr', 'ja', 'ko', 'pt']
